import styled from 'styled-components/macro';
import { Link } from 'components';

export const LinkStyled = styled(Link)`
  &:hover {
    text-decoration: none;
  }
`;
